export default __webpack_public_path__ + "static/media/IconOff.cc205fb5.svg";